var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"funiswap-menu"},[_c('f-simple-navigation',{attrs:{"items":_vm.navigation,"aria-label":"fUni navigation"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }